import { AlertsService } from '../service/alerts.service'
import { icon } from '@fortawesome/fontawesome-svg-core'

export const alertMixins = {
  data () {
    return {
      demoAlert: 'Alert 123'
    }
  },

  methods: {
    // error
    errorAlert (text = null, actionType = null) {
      return AlertsService.errorActionAlert(text, actionType)
    },

    // info
    infoAlert (text = null, actionType = null) {
      return AlertsService.infoActionAlert(text, actionType)
    },

    // question
    questionAlert (text = null, actionType = null, icon = 'question') {
      return AlertsService.questionActionAlert(text, actionType, icon)
    },

    // success
    successAlert (text = null, actionType = null) {
      return AlertsService.successActionAlert(text, actionType)
    },

    // warning
    warningAlert (text = null, actionType = null) {
      return AlertsService.warningActionAlert(text, actionType)
    },

    // custom
    customAlert (text = null, actionType = null, html = null) {}

  },

  computed: {},

  mounted () {},

  created () {}

}

export default { alertMixins }
